import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography } from 'antd';
import PersonalnformationForm from '../../../../components/mobile/sign-up/PersonalnformationForm';
import { ReactComponent as EmployeeSvg } from '../../../../assets/icons/sign-up/employees.svg';

const { Title, Paragraph } = Typography;

const styles = {
  title: {
    fontWeight: "300",
    fontSize: "20px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#404047",
    marginBottom: 10
  },
  subtitle: {
    fontWeight: "400",
    fontSize: "18px",
    lineHeight: "28px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    textTransform: "capitalize",
    color: "#15A9E1",
    marginBottom: 33,
  }
}

function MobilePersonalInfoScreen() {
  const { t } = useTranslation(['sign-up', 'common']);

  return (
    <>
      <Box display="flex" justifyContent="center">
        <EmployeeSvg style={{ margin: '20', maxWidth: '80%' }} />
      </Box>
      <Box textAlign="center">
        <Row gutter={[0, 24]}>
          <Col xs={24}>
            <Title level={4} style={styles.title}>
              {t('sign-up:guest.signUpForAlemHealth')}
            </Title>
            <Row justify="center">
              <Paragraph style={styles.subtitle}>
                {t('sign-up:guest.tellAboutYourSelf')}
              </Paragraph>
            </Row>
          </Col>
        </Row>
      </Box>
      <PersonalnformationForm onSubmitBtnText={t('sign-up:guest.nextStepAccountDetail')} />
    </>
  );
}

export default MobilePersonalInfoScreen;
